<script setup lang="ts">
import { RouterLink } from 'vue-router'
import type { Competition } from '../api/competitions'

defineProps<{
	competition: Competition
}>()

function prettyPrintStatus(status: Competition['status']): string {
	switch (status) {
		case 'accepting_submissions': return 'Open'
		case 'closed': return 'Closed'
		case 'running': return 'Running now!'
		case 'completed': return 'Completed'
	}
}
</script>

<template>
	<section :class="['c-comp-details', `c-comp-details--${competition.status}`]">
		<div class="c-comp-details__status">{{ prettyPrintStatus(competition.status) }}</div>

		<div class="c-comp-details__body">
			<div>
				<h3>{{ competition.name }}</h3>
				<p>
					Created by {{ competition.organizers.map(o => o.display_name).join(', ') }}
					on {{ new Date(competition.created_at).toLocaleString() }}
				</p>
			</div>

			<RouterLink :to="`/competitions/${competition.id}`" class="c-button">View</RouterLink>
		</div>
	</section>
</template>
